const home = {
  // Hero
  hero_headline_1: 'A Liderança que sua',
  hero_headline_family: 'Família',
  hero_headline_and: 'e',
  hero_headline_school: 'Escola',
  hero_headline_2: 'precisam',
  hero_description: 'Transforme suas relações familiares e gestão educacional com metodologias comprovadas por <strong>17 anos de experiência</strong>. Descubra o caminho para uma liderança que gera resultados reais e duradouros.',
  hero_btn_books: 'Livros',
  hero_btn_courses: 'Cursos',
  hero_btn_mentorship: 'Mentoria SÍLEX',
  hero_stat_experience: 'Anos de Experiência',
  hero_stat_mba: 'USP/Esalq',

  // Books section
  books_title: 'Os Livros e obras:',
  books_title_highlight: 'O Início da Transformação',
  books_subtitle: 'Livros e e-books que já transformaram milhares de famílias e profissionais da educação em todo o Brasil',
  books_format: 'E-book PDF',
  books_btn_buy: 'Comprar',
  books_btn_details: 'Ver Detalhes',
  books_guarantee: 'Garantia de 7 dias',
  books_coming_soon: 'Em Breve',
  books_coming_new: 'Novo título em breve',
  books_coming_desc: 'Estamos preparando mais conteúdo incrível para você!',
  books_notify_label: 'Avise-me quando lançar',
  books_details_hover: 'Ver Detalhes',

  // Courses section
  courses_title: 'Formação de Elite:',
  courses_title_highlight: 'O Método Completo',
  courses_subtitle: 'Cursos online estruturados com metodologias validadas por mais de 17 anos de experiência prática',
  courses_badge: 'Curso Online',
  courses_modules: 'módulos',
  courses_btn_enroll: 'Matricular Agora',
  courses_btn_details: 'Ver Detalhes',
  courses_guarantee: 'Garantia de 30 dias',
  courses_coming_new: 'Novo curso em breve',
  courses_coming_desc: 'Estamos preparando uma nova formação incrível para você!',
  courses_students: 'alunos',
  courses_or: 'ou',
  courses_hover_view: 'Ver Curso',
  courses_testimonials_title: 'O Que Nossos Alunos Dizem',

  // SÍLEX Showcase (Vitrine SÍLEX na Home)
  silex_showcase_eyebrow: 'Método SÍLEX · 48 etapas',
  silex_showcase_title: 'Mentoria',
  silex_showcase_title_highlight: 'SÍLEX',
  silex_showcase_subtitle: 'Para pais e educadores que decidiram parar de disputar atenção — e começar a reconstruir presença, respeito e direção.',
  silex_showcase_body: 'Um método de cinco pilares para substituir o ruído dos confrontos pela clareza do diálogo, instalando uma aliança de respeito mútuo e engajamento prático entre pais, educadores e jovens.',
  silex_showcase_benefits_kicker: 'O que você recebe',
  silex_showcase_benefit_1_title: 'Método completo em 48 etapas',
  silex_showcase_benefit_1_desc: 'As 48 etapas do método, do diagnóstico à consolidação. Presente nos três planos, sem versão reduzida.',
  silex_showcase_benefit_2_title: 'Liberação por conclusão, não por calendário',
  silex_showcase_benefit_2_desc: 'Cada etapa abre quando a anterior é concluída. Você avança no seu ritmo, sem pular fundamento.',
  silex_showcase_benefit_3_title: 'Lives coletivas com o mentor',
  silex_showcase_benefit_3_desc: 'Três no Spark, seis no Lab, quinzenais no Protag. Encontros ao vivo para tirar dúvidas e ver o método aplicado a casos reais.',
  silex_showcase_benefit_4_title: 'Encontros individuais',
  silex_showcase_benefit_4_desc: 'Dois no Lab, de dois a quatro no Protag. Sessões reservadas ao seu cenário específico.',
  silex_showcase_benefit_5_title: 'Suporte no canal do seu plano',
  silex_showcase_benefit_5_desc: 'Pela plataforma no Spark, em grupo no Lab, direto no WhatsApp no Protag.',
  silex_showcase_benefit_6_title: 'Acesso por tempo definido',
  silex_showcase_benefit_6_desc: '90 dias no Spark, 180 no Lab, 365 no Protag. Compra única, sem assinatura e sem renovação automática.',
  silex_showcase_cta_secondary: 'Ver planos e detalhes',
  silex_showcase_plans_kicker: 'Conheça os três planos',
  silex_showcase_plan_spark_name: 'SÍLEX Spark',
  silex_showcase_plan_spark_price: 'R$ 997',
  silex_showcase_plan_spark_duration: '90 dias',
  silex_showcase_plan_spark_tagline: 'Começar com clareza',
  silex_showcase_plan_lab_name: 'SÍLEX Lab',
  silex_showcase_plan_lab_price: 'R$ 2.997',
  silex_showcase_plan_lab_duration: '180 dias',
  silex_showcase_plan_lab_tagline: 'Implementar com consistência',
  silex_showcase_plan_protag_name: 'SÍLEX Protag',
  silex_showcase_plan_protag_price: 'R$ 8.997',
  silex_showcase_plan_protag_duration: '365 dias',
  silex_showcase_plan_protag_tagline: 'O caminho principal',
  silex_showcase_plan_protag_highlight: 'Recomendado',
  silex_showcase_plan_duration_label: 'de acesso',
  silex_showcase_plan_card_cta: 'Ver detalhes',
  silex_showcase_plans_note: 'Opções de parcelamento disponíveis no checkout.',
  silex_showcase_guarantee_title: 'Garantia SÍLEX de Clareza e Aplicação',
  silex_showcase_guarantee_text: 'Sete dias para verificar se a estrutura faz sentido para o seu contexto. Se não fizer, o cancelamento é seu direito, sem burocracia.',
  silex_showcase_cta_primary: 'Conhecer a Mentoria SÍLEX',

  // Action Center
  action_title: 'Seu Próximo Passo:',
  action_title_highlight: 'Central de Ação',
  action_subtitle: 'Escolha o caminho ideal para sua transformação',
  action_quick_title: 'Início Rápido',
  action_quick_desc: 'Comece hoje mesmo com nossos e-books e transforme sua gestão',
  action_quick_btn: 'Ver Livros',
  action_deep_title: 'Formação Completa',
  action_deep_desc: 'Domine todas as estratégias com nossos cursos estruturados',
  action_deep_btn: 'Ver Cursos',
  action_deep_badge: 'MAIS POPULAR',
  action_elite_title: 'Acesso Elite',
  action_elite_desc: 'Mentoria exclusiva para resultados extraordinários',
  action_faq_title: 'Perguntas Frequentes',
  action_faq_q1: 'Como funciona o acesso aos cursos?',
  action_faq_a1: 'Após a compra, você recebe acesso imediato e vitalício ao conteúdo completo, podendo estudar no seu próprio ritmo.',
  action_faq_q2: 'Os e-books são em formato físico ou digital?',
  action_faq_a2: 'Todos os nossos livros são em formato PDF digital, permitindo acesso instantâneo após a compra.',
  action_faq_q3: 'Qual a diferença entre os cursos e a mentoria?',
  action_faq_a3: 'Os cursos são conteúdos estruturados para aprendizado autônomo. A mentoria é um acompanhamento personalizado e exclusivo.',
  action_faq_q4: 'Existe garantia de satisfação?',
  action_faq_a4: 'Sim! Oferecemos 7 dias de garantia para e-books e 30 dias para cursos. Se não ficar satisfeito, devolvemos seu investimento.',
  action_faq_q5: 'Como funciona o processo de candidatura para mentoria?',
  action_faq_a5: 'Após preencher o formulário, nossa equipe analisa seu perfil e entra em contato em até 24 horas para agendar uma conversa.',
  action_cta_title: 'Pronto para Transformar sua Liderança?',
  action_cta_desc: 'Junte-se aos profissionais que já transformaram suas vidas com nossos métodos',
  action_cta_btn_explore: 'Explorar Produtos',

  // Social Proof
  social_title: 'Conteúdo Exclusivo no Instagram',
  social_subtitle: 'Acompanhe conteúdos de gestão educacional e relações familiares',
  social_follow: 'Seguir Agora',

  // Footer
  footer_partner_label: 'Projeto parceiro',
  footer_partner_name: 'Protocolo & Conexão',
  footer_partner_desc: 'Palestras e formações para escolas, famílias e empresas.',
  footer_partner_cta: 'Conhecer o projeto',
  footer_brand_desc: 'Transformando líderes educacionais e famílias através de metodologias comprovadas há mais de 17 anos.',
  footer_products_title: 'Produtos',
  footer_products_books: 'Livros e E-books',
  footer_products_courses: 'Cursos Online',
  footer_products_talks: 'Palestras In-Company',
  footer_products_webinars: 'Webinars ao Vivo',
  footer_company_title: 'Empresa',
  footer_company_about: 'Sobre Nós',
  footer_company_contact: 'Contato',
  footer_support_title: 'Suporte',
  footer_support_help: 'Central de Ajuda',
  footer_support_privacy: 'Política de Privacidade',
  footer_support_terms: 'Termos de Uso',
  footer_support_refund: 'Falar sobre reembolso',
  footer_copyright: '© {{ano}} SB Family & Mastery. Todos os direitos reservados.',
  footer_secure: 'Site Seguro',
  footer_payment: 'Pagamento Protegido',

  // FAQ Page
  faq_badge: 'Central de Ajuda',
  faq_title: 'Como podemos ajudar?',
  faq_subtitle: 'Encontre respostas para as dúvidas mais comuns sobre a plataforma, cursos, pagamentos e certificados.',
  faq_cat_geral: 'Geral',
  faq_cat_acesso: 'Acesso & Conta',
  faq_cat_cursos: 'Cursos',
  faq_cat_pagamento: 'Pagamento',
  faq_cat_certificado: 'Certificados',
  faq_cat_mentoria: 'Mentoria',
  faq_not_found_title: 'Não encontrou o que precisava?',
  faq_not_found_desc: 'Nossa equipe de suporte está disponível para ajudar de segunda a sexta, das 8h às 18h.',
  faq_not_found_btn: 'Falar com o Suporte',

  // Cursos Page
  cursos_badge: 'Formações de Elite',
  cursos_title: 'Catálogo de',
  cursos_title_highlight: 'Cursos',
  cursos_subtitle: 'Metodologias comprovadas para transformar sua gestão educacional e suas relações familiares.',
  cursos_stat_courses: 'cursos disponíveis',
  cursos_stat_rating: 'Avaliação média 4.8',
  cursos_stat_guarantee: 'Garantia de 30 dias',
  cursos_search_placeholder: 'Buscar cursos...',
  cursos_filter_all_areas: 'Todas as Áreas',
  cursos_filter_all_levels: 'Todos os Níveis',
  cursos_filter_all_durations: 'Qualquer Duração',
  cursos_filter_clear: 'Limpar',
  cursos_results_found_one: 'curso encontrado',
  cursos_results_found_many: 'cursos encontrados',
  cursos_results_none: 'Nenhum curso encontrado',
  cursos_no_results_title: 'Nenhum resultado encontrado',
  cursos_no_results_desc: 'Tente ajustar os filtros ou buscar com outras palavras.',
  cursos_no_results_btn: 'Limpar Filtros',
  cursos_badge_online: 'Curso Online',
  cursos_modules_label: 'módulos',
  cursos_enroll_btn: 'Matricular Agora',
  cursos_details_btn: 'Ver Detalhes',
  cursos_view_btn: 'Ver Curso',
  cursos_cta_title: 'Quer Resultado Mais Rápido?',
  cursos_cta_desc: 'A Mentoria Premium é a forma mais direta de transformar sua escola ou família com acompanhamento personalizado.',
  cursos_students_label: 'alunos',
  cursos_or_label: 'ou',

  // Sobre Page
  sobre_badge: 'Sobre Nós',
  sobre_title: '17 anos formando líderes que transformam',
  sobre_subtitle: 'A SB Family & Mastery nasceu da convicção de que liderança genuína começa no lar e se expande para as instituições. Somos uma plataforma de educação executiva com missão clara: transformar famílias e escolas por meio de conhecimento aplicável.',
  sobre_mission_label: 'Nossa Missão',
  sobre_vision_label: 'Nossa Visão',
  sobre_purpose_label: 'Nosso Propósito',
  sobre_mission_text: 'Capacitar líderes educacionais e familiares com ferramentas práticas e metodologias comprovadas que gerem transformação real e mensurável na vida de pessoas e instituições.',
  sobre_vision_text: 'Ser a principal referência em educação executiva para gestão familiar e escolar do Brasil, formando uma geração de líderes que constroem legados duradouros.',
  sobre_purpose_text: 'Acreditamos que cada família fortalecida e cada escola bem gerida produz ondas de impacto positivo que atravessam gerações. É por isso que fazemos o que fazemos.',
  sobre_values_title: 'Nossos Valores',
  sobre_values_desc: 'Os pilares que guiam cada decisão, cada conteúdo e cada interação da nossa equipe.',
  sobre_team_badge: 'Quem está por trás',
  sobre_team_title: 'Nosso Corpo Fundador',
  sobre_team_desc: 'Profissionais com sólida experiência combinada em educação, psicologia e tecnologia.',
  sobre_timeline_title: 'Nossa Jornada',
  sobre_timeline_desc: '17 anos de história, aprendizado e impacto.',
  sobre_cta_title: 'Faça parte da transformação',
  sobre_cta_desc: 'Junte-se às famílias e educadores que já escolheram crescer com a SB Family & Mastery.',
  sobre_cta_contact: 'Fale Conosco',

  // Contato Page
  contato_badge: 'Fale Conosco',
  contato_title: 'Estamos aqui para te ajudar',
  contato_subtitle: 'Nossa equipe de suporte responde em até 24 horas úteis. Escolha o canal mais conveniente para você.',
  contato_form_title: 'Enviar uma mensagem',
  contato_form_desc: 'Preencha o formulário abaixo e retornaremos em até 24 horas úteis.',
  contato_name_label: 'Nome completo *',
  contato_email_label: 'E-mail *',
  contato_subject_label: 'Assunto',
  contato_message_label: 'Mensagem *',
  contato_send_btn: 'Enviar Mensagem',
  contato_sending: 'Enviando...',
  contato_success_title: 'Mensagem enviada!',
  contato_success_desc: 'Nossa equipe retornará em até 24 horas úteis.',
  contato_success_new: 'Enviar nova mensagem',
  contato_error: 'Erro ao enviar. Tente novamente ou use outro canal.',
  contato_faq_title: 'Dúvidas Rápidas',
  contato_faq_desc: 'Talvez sua dúvida já esteja respondida no nosso FAQ:',
  contato_faq_all: 'Ver toda a Central de Ajuda',
  contato_hours_title: 'Horários de Atendimento',
  contato_online: 'Suporte online agora',
  contato_hours_weekday: 'Segunda – Sexta',
  contato_hours_weekday_val: '8h às 18h',
  contato_hours_saturday: 'Sábado',
  contato_hours_saturday_val: '9h às 13h',
  contato_hours_sunday: 'Domingo e Feriados',
  contato_hours_sunday_val: 'Fechado',
};

export default home;
